import { ConfigurationStatus } from "@/api/dtos";
import InstitutionContext from "@/contexts/data/InstitutionContext";
import InstitutionsContext from "@/contexts/data/InstitutionsContext";
import ParticipantContext from "@/contexts/data/ParticipantContext";
import ParticipantsContext from "@/contexts/data/ParticipantsContext";
import TrialContext from "@/contexts/data/TrialContext";
import { LinkContext } from "@/contexts/layouts/LinkContext";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Divider, Menu, MenuItem, styled } from "@mui/material";
import { FC, MouseEvent, useContext, useMemo, useState } from "react";
import { Link as RouteLink } from 'react-router-dom';

const StyledDivider = styled(Divider)(({ theme}) => ({
    margin: `0 !important`
}));

const NavigationParticipantSelector: FC = () => {
    const { createTrialLink, createInstitutionLink, createParticipantLink, participantLinkEnabled } = useContext(LinkContext);
    
    const { data: trial} = useContext(TrialContext);
    const { data: institution } = useContext(InstitutionContext);
    const { data: participant } = useContext(ParticipantContext);
    const { idMap: institutions } = useContext(InstitutionsContext);
    const { data: participants } = useContext(ParticipantsContext);
    
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleMenu = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const list = useMemo(() => {
        if (!trial || !institutions) {
            return undefined;
        }
        
        return participants?.filter(x => !!x.status && x.status !== ConfigurationStatus.Disabled).map((x, i, a) => {
            return (
                [
                    <MenuItem key={x.oid} component={RouteLink} to={createParticipantLink(trial, x.institutionId ? institutions[x.institutionId] : undefined, x)} onClick={handleClose}>{x.studyNumber}</MenuItem>,
                    i < (a.length - 1) ? <StyledDivider key={`${x.id}-divider`} /> : null
                ]
            );
        })
    }, [participants, trial, institutions, createParticipantLink, handleClose])

    if (!participantLinkEnabled || !trial) {
        return null;
    }
    
    return (
        <>
            <Button
                id="btn-participants"
                color="inherit"
                aria-label="participant selection"
                aria-controls="menu-participants"
                aria-haspopup="true"
                sx={{mr: 2}}
                onClick={handleMenu}
                endIcon={<FontAwesomeIcon icon={faChevronDown} fixedWidth style={{fontSize: '1rem'}} />}
            >
                {
                    participant ?
                        participant.studyNumber :
                        'All Participants'
                }
            </Button>
            <Menu
                id="menu-participants"
                anchorEl={anchorEl}
                keepMounted
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={anchorEl?.id === 'btn-participants'}
                onClose={handleClose}
                MenuListProps={{
                    disablePadding: true
                }}
            >
                <MenuItem component={RouteLink} to={institution ? createInstitutionLink(trial, institution) : createTrialLink(trial)} onClick={handleClose}>All Participants</MenuItem>
                <StyledDivider />
                {
                    list
                }
            </Menu>
        </>
    )
}

export default NavigationParticipantSelector;